<template>
    <div :style="getStyles"
         class="text-main-2xl main-text-color flex items-center font-medium truncate">
        {{ getDateInterval }}
    </div>
</template>
<script>
import { timeFilterToHuman, timeFilterForPeriod } from '@/helpers/widgetUtils'

export default {
    props: {
        widget: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getStyles () {
            return this.$store.getters['layout/widgetTitleStyles']('activeLayout')
        },
        getDateInterval () {
            const widgetTime = this.widget.WidgetTime

            if (widgetTime.type === 'period') {
                return timeFilterForPeriod(
                    widgetTime.period_type,
                    widgetTime.periods_back,
                    'dd.MM.yyyy',
                    widgetTime.is_calendrical
                )
            }

            return timeFilterToHuman(this.widget, 'dd.MM.yyyy')
        }
    }
}
</script>
